"use client";

import { onIdTokenChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "@/lib/firebase";
import { mayHaveMultipleTenants } from "@/lib/tenant-claims";

/**
 * Whether the signed-in user's claims could reach more than one clinic, so the
 * clinic switcher is worth fetching. False until the claims are read.
 *
 * Follows token refreshes, so someone added to a second clinic gets the
 * switcher once their token picks up the new claim, without a reload.
 */
export function useMayHaveMultipleTenants(): boolean {
  const [mayHaveMultiple, setMayHaveMultiple] = useState(false);
  useEffect(() => {
    let latest = 0;
    const unsubscribe = onIdTokenChanged(auth, async user => {
      const call = ++latest;
      if (!user) {
        setMayHaveMultiple(false);
        return;
      }
      let result = true;
      try {
        const {
          claims
        } = await user.getIdTokenResult();
        result = mayHaveMultipleTenants(claims);
      } catch {
        // Unreadable claims: fetch the list rather than hide the switcher.
      }
      if (call === latest) setMayHaveMultiple(result);
    });
    return () => {
      latest = -1;
      unsubscribe();
    };
  }, []);
  return mayHaveMultiple;
}